
// Upgrade thresholds are measured in collected coins
export const LEVELS = [
    { start: 0, end: 18 },
    { start: 18, end: 40 },
    { start: 40, end: 70 },
    { start: 70, end: 100 },
] as const

export type LevelProgress = {
    level: number
    progress: number
    current: number
    target: number
}

export function getLevelProgress(points: number): LevelProgress {
    const floored = Math.floor(points)
    for (let i = 0; i < LEVELS.length; i++) {
        const { start, end } = LEVELS[i]
        if (floored < end) {
            return {
                level: i + 1,
                progress: (floored - start) / (end - start),
                current: floored - start,
                target: end - start,
            }
        }
    }
    const last = LEVELS[LEVELS.length - 1]
    return {
        level: LEVELS.length,
        progress: 1,
        current: last.end - last.start,
        target: last.end - last.start,
    }
}